import formStyle from '@/styles/modules/form.module.scss';
import { useController } from 'react-hook-form';
import type { DeepMap, FieldError, FieldValues, UseControllerProps } from 'react-hook-form/dist/types';
import FormLabel from '../../form/FormLabel/FormLabel';
import styles from './FormSelect.module.scss';

type Props<T extends FieldValues> = {
  label?: string;
  placeholder?: string;
  items: Array<{ value: string | number; text: string }>;
  required?: boolean;
  outlined?: boolean;
  onChange?: () => void;
  hint?: string;
  disabled?: boolean;
} & UseControllerProps<T>;

function FormSelect<T extends FieldValues>({
  name,
  items,
  label,
  placeholder,
  required = false,
  control,
  outlined = false,
  onChange,
  hint,
  disabled = false,
}: Props<T>) {
  const options = items.map((v) => (
    <option key={v.value} value={v.value}>
      {v.text}
    </option>
  ));

  const {
    field,
    fieldState: { error },
  } = useController<T>({ name, control });

  return (
    <div className={formStyle.formComponentStyle}>
      {/* ラベル */}
      {label && <FormLabel required={required}>{label}</FormLabel>}
      {/* フィールドブロック */}
      <div className={error && formStyle.hasError}>
        <div className={`${formStyle.fieldWrapper} ${styles.selectWrapper} ${outlined ? styles.outlined : ''}`}>
          <select
            required={required}
            name={field.name}
            ref={field.ref}
            onBlur={field.onBlur}
            onChange={(e) => {
              field.onChange(e);
              // biome-ignore lint/complexity/useOptionalChain: <explanation>
              onChange && onChange();
            }}
            value={field.value ?? ''}
            className={`${styles.select} ${!field.value && styles.placeholder}`}
            disabled={disabled}
          >
            {/* placeholderは1つ目の選択肢扱いにして表示 */}
            {placeholder && (
              <option value='' disabled hidden>
                {placeholder}
              </option>
            )}
            {options}
          </select>
          <div className={styles.appearance} />
        </div>
        {hint && <p className={formStyle.hint}>{hint}</p>}
        {/* エラー */}
        {error && <p className={formStyle.validateErrors}>{(error as DeepMap<FieldValues, FieldError>).message}</p>}
      </div>
    </div>
  );
}
export default FormSelect;
